import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';

export const useReceipt = (carId) => {
   const api = "" 
   //useEffect(() => {
   // fetchReceipts(carId, typeId);
   //}, []);

   const fetchReceipts = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
        type_id: 3,
      };
  
      automobyApi
        .post("/receipt/list", requestData)
        .then(response => {
          resolve(response.data.receipts);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

 
  
  const addReceiptCar = (newReceipt) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/receipt/add", newReceipt)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };



  const removeReceipt = (receiptId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        receipt_id: receiptId
      };
  
      automobyApi
        .post("/receipt/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchByCarId = (carId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
        type_id: 3,
      };
  
      automobyApi
        .post("/receipt/list", requestData)
        .then(response => {
          resolve(response.data.receipts);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  
  const receiptService = {
    fetchReceipts: fetchReceipts,
    addReceiptCar: addReceiptCar,
    removeReceipt: removeReceipt, 
    fetchByCarId:fetchByCarId,
 
   };

  return { receiptService };
 
}